<template>
    <label class="pp-radio"
        :class="[
            'pp-radio--' + currentSize,
            {'is-active': isActive, 'is-disabled': isDisabled}]"
        @click="change">
        <input class="pp-radio__input" 
            type="radio" 
            v-bind="$attrs"
            :value="label" 
            :checked="checked" :disabled="isDisabled"
        />
        <i class="pp-radio__icon" :class="[isActive ? currentActiveIcon : currentIcon]"
            :style="{color: isDisabled ? '#ddd' : isActive ? currentColor : '#666', float: currentAlign}"></i>
        <span class="pp-radio__label" :style="{color: isActive ? currentColor : '#666'}">
            <slot></slot>
        </span>
    </label>
</template>

<script>
/**
 * 单选
 * @param {[string, number]} value v-model绑定值
 * @param {[string, number]} label 选中值
 * @param {string} icon 默认图标
 * @param {string} activeIcon 选中图标
 * @param {string} color 选中颜色
 * @param {boolean} checked 默认选中
 * @param {boolean} disabled 失效状态
 * @param {string} size 尺寸[normal(default), small, mini]
 * @param {string} align 按钮对齐方式 ['right']
 * @event change 绑定值改变时触发，参数为改变后的值
 */
export default {
    name: 'pp-radio',
    inheritAttrs: false,
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
        RadioGroup: {
            default: ''
        },
    },
    props: {
        value: [String, Number],
        label: [String, Number],
        icon: {
            type: String,
            default: 'pp-icon-circular',
        },
        activeIcon: {
            type: String,
            default: 'pp-icon-radio'
        },
        color: String,
        checked: Boolean,
        disabled: Boolean,
        size: {
            type: String,
            default: 'normal',
        },
        align: {
            type: String,
            validator: function(value) {
                return ['right'].includes(value);
            },
        },
    },
    computed: {
        isGroup: function() {
            return this.$parent.$options.name === 'pp-radio-group';
        },
        isActive: function() {
            return this.label === this.currentValue;
        },
        isDisabled: function() {
            return this.Form.disabled 
                || (this.isGroup ? this.$parent.currentDisabled : this.disabled)
                || this.disabled;
        },
        currentValue: function() {
            return this.isGroup ? this.$parent.value : this.value;
        },
        currentIcon: function() {
            return this.isGroup 
                ? this.$parent.icon || this.icon 
                : this.icon;
        },
        currentActiveIcon: function() {
            return this.isGroup 
                ? this.$parent.activeIcon || this.activeIcon 
                : this.activeIcon;
        },
        currentColor: function() {
            return this.isGroup 
                ? this.$parent.color || this.color 
                : this.color;
        },
        currentSize: function() {
            return this.Form.size 
                || this.FormItem.size 
                || this.RadioGroup.size
                || this.size;
        },
        activeColor: function() {
            return (this.isActive && this.currentColor) ? this.currentColor : '';
        },
        currentAlign: function() {
            return this.align || this.RadioGroup.align;
        },
    },
    methods: {
        change: function() {
            if(this.isDisabled) return;

            this.isGroup 
                ? this.$parent.update(this.label) 
                : this.$emit('input', this.label)
            this.$emit('change', this.label)
        },
    },
    created: function() {
        this.checked && this.change()
    },
}
</script>

<style lang="scss" scoped>
.pp-radio {
    cursor: pointer;
}
</style>

